export default function PrivacyData() {
  return {
    title: "Your information is always private",
    description: "We strive to be worthy of protecting your private information. In all of our processes we try to reduce the amount of information you have to enter, both to protect your privacy and to keep the process simple. The information you do give us is only shared with parties who require it to complete your quotes and product applications.",
    iconName: "m_shieldLocked",
  };
};